var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserRoleManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9864 7.94614C18.9264 7.93614 18.8564 7.93614 18.7964 7.94614C17.4164 7.89614 16.3164 6.76613 16.3164 5.36613C16.3164 3.93613 17.4664 2.78613 18.8964 2.78613C20.3264 2.78613 21.4764 3.94613 21.4764 5.36613C21.4664 6.76613 20.3664 7.89614 18.9864 7.94614Z",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9563 15.2262C19.3263 15.4562 20.8363 15.2162 21.8963 14.5062C23.3063 13.5662 23.3063 12.0262 21.8963 11.0862C20.8263 10.3762 19.2963 10.1362 17.9263 10.3762",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95631 7.94614C7.01631 7.93614 7.08631 7.93614 7.14631 7.94614C8.52631 7.89614 9.62631 6.76613 9.62631 5.36613C9.62631 3.93613 8.47631 2.78613 7.04631 2.78613C5.61631 2.78613 4.46631 3.94613 4.46631 5.36613C4.47631 6.76613 5.57631 7.89614 6.95631 7.94614Z",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98627 15.2262C6.61627 15.4562 5.10627 15.2162 4.04627 14.5062C2.63627 13.5662 2.63627 12.0262 4.04627 11.0862C5.11627 10.3762 6.64627 10.1362 8.01627 10.3762",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9864 15.4161C12.9264 15.4061 12.8564 15.4061 12.7964 15.4161C11.4164 15.3661 10.3164 14.2361 10.3164 12.8361C10.3164 11.4061 11.4664 10.2561 12.8964 10.2561C14.3264 10.2561 15.4764 11.4161 15.4764 12.8361C15.4664 14.2361 14.3664 15.3761 12.9864 15.4161Z",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0765 18.5661C8.66654 19.5061 8.66654 21.0461 10.0765 21.9861C11.6765 23.0561 14.2965 23.0561 15.8965 21.9861C17.3065 21.0461 17.3065 19.5061 15.8965 18.5661C14.3065 17.5061 11.6765 17.5061 10.0765 18.5661Z",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoleManagement);
export default __webpack_public_path__ + "static/media/user-role-management.0618742017c4bce47e1d4ed59a5c85a9.svg";
export { ForwardRef as ReactComponent };